import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FuseDeleteDialogComponent } from '../../../../core/components/delete-dialog/delete-dialog.component';
import { EventService } from '../../../../core/services/event.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { RecommendationService } from '../../../../core/services/recommendation.service';
import { RecommendationDetailModal } from '../recommendation-detail-modal/recommendation-detail.modal';

@Component({
  selector: 'recommended-event',
  templateUrl: './recommended-event.component.html',
  styleUrls: ['./recommended-event.component.scss'],
  standalone: false
})

export class RecommendedEventComponent {
  @Input() event: any;
  @Input() index: any;
  @Output() deleteEvent = new EventEmitter();
  @Output() removeFavorite = new EventEmitter();

  constructor(private eventService: EventService, public snackBar: MatSnackBar,
              private translate: TranslateService, public dialog: MatDialog,
              private recommendationService: RecommendationService) {
  }

  getEventImage(name) {
    return this.eventService.getFileStream(name);
  }

  toggleFavorite(event) {
    if (event.isFavorite && event.favId) {
      this.recommendationService.removeFavoriteRecommendation(event.favId).subscribe((result) => {
        event.isFavorite = false;
        event.favId = null
        this.removeFavorite.emit(this.index);
      });
    } else {
      let data = {
        recommendationId: event.id,
      }
      this.recommendationService.addFavoriteRecommendation(data).subscribe((result: any) => {
        event.isFavorite = true;
        event.favId = result.id;
      });
    }
  }

  subscriptionToEvent (id, index) {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'main.subscription' , message: 'event.subscription_question'}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.eventService.subscriptionToEvent({eventId: id}).subscribe((res) => {
          if (res) {
            this.deleteEvent.emit(index);
            let message = this.translate.instant('event.subscription_confirm_message');
            this.snackBar.open(message , 'OK' , {
              verticalPosition: 'top' ,
              panelClass: 'sub-to-event-bar'
            });
          }
        });
      }
    });
  }

  openDetail(event, index){
    const dialogRef = this.dialog.open(RecommendationDetailModal, {
      width: '80%',
      height: '90vh',
      data: {event: JSON.parse(JSON.stringify(event))}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.subscriptionToEvent(event.event.id, index)
      }
    })
  }
}
